import { styled } from "@mui/material/styles";

import { Table as BaseTable } from "ui";

export const StyledTable = styled(BaseTable)(({ theme }) => ({
  "& .MuiTableContainer-root": {
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));
